import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "conversation-wrapper new-conversation" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center" }
const _hoisted_4 = { class: "me-1 d-block d-md-none" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", { class: "me-1 ps-2 ps-md-3" }, "To: ", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "d-flex w-100 align-items-baseline group-name"
}
const _hoisted_9 = {
  class: "me-1 ps-3",
  style: {"white-space":"nowrap"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Group Name ")
const _hoisted_11 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-2" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_15 = { class: "form-group w-100" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("section", { class: "conversation-body" }, [
  /*#__PURE__*/_createCommentVNode(" DO NOT DELETE THIS SECTION ")
], -1 /* HOISTED */)
const _hoisted_18 = { class: "conversation-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_ChatSummerEditor = _resolveComponent("ChatSummerEditor")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!
  const _directive_alphanumeric_dash_space_only = _resolveDirective("alphanumeric-dash-space-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeBacktoConnect && _ctx.routeBacktoConnect(...args)))
          }, _hoisted_6)
        ]),
        _hoisted_7,
        _createVNode(_component_TagsInput, {
          class: "w-100",
          getData: _ctx.getUsersList,
          tags: _ctx.users,
          onUpdateTags: _ctx.updateTags,
          placeholder: "Start Typing a Name",
          "is-focus": true,
          "is-for-messaging": true,
          "show-pill": false,
          classes: "w-100 form-group pt-2 mt-1",
          focusOnInput: "true",
          tabindex: "1"
        }, null, 8 /* PROPS */, ["getData", "tags", "onUpdateTags"])
      ]),
      (_ctx.users?.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("b", _hoisted_9, [
              _hoisted_10,
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, _hoisted_13)), [
                [_directive_custom_popover, { content: _ctx.groupNameTooltip, className: 'info-popup' }]
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control border-0",
                value: _ctx.newChatTitle,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateTitle($event.target.value))),
                placeholder: "Enter Group Name (Optional)",
                maxlength: "250",
                tabindex: "2"
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16), [
                [_directive_alphanumeric_dash_space_only]
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_17,
    _createElementVNode("footer", _hoisted_18, [
      (_openBlock(), _createBlock(_component_ChatSummerEditor, {
        key: `new-chat-editor`,
        isNewConversation: true
      }))
    ])
  ]))
}